module.exports = __webpack_public_path__ + "img/mapp.b6608de4.jpg";